import { TokenResponse, useGoogleLogin } from '@react-oauth/google'
import * as Sentry from '@sentry/react'
import {
  ILoginPayload,
  OAUTH_GRANT_TYPE,
  PRODUCT_TYPE,
  SOCIAL_LOGIN_PROVIDER,
  loginWithProvider,
} from '../../modules/auth'
import useAppRouter from '../../modules/hooks/common/useAppRouter'
import { DEFAULT_LOCALE, LOCALE_KEY, LocaleType } from '../../modules/i18n/config'
import { SOCIAL_LOGIN_PREFIX } from '../../modules/vars'

interface GoogleLoginProps {
  locale: LocaleType
  isMobile: boolean
  additionalOnClick?: () => void
  render: React.ReactNode
}

const GoogleLogin = ({ locale, isMobile, additionalOnClick, render }: GoogleLoginProps) => {
  const router = useAppRouter()

  const onSuccess = async (tokenResponse: Omit<TokenResponse, 'error' | 'error_description' | 'error_uri'>) => {
    const payload: ILoginPayload = {
      grant_type: OAUTH_GRANT_TYPE.PASSWORD,
      username: SOCIAL_LOGIN_PREFIX + SOCIAL_LOGIN_PROVIDER.GOOGLE,
      password: tokenResponse?.access_token,
      locale: locale == LOCALE_KEY ? DEFAULT_LOCALE : locale,
      product_type: PRODUCT_TYPE.PLUS,
      google_token_type: 'access_token',
    }

    try {
      await loginWithProvider(router, payload, isMobile, null, SOCIAL_LOGIN_PROVIDER.GOOGLE)
    } catch (error) {
      console.log(tokenResponse)
      Sentry.captureException('구글 로그인 실패', { extra: { response: tokenResponse, error } })
    }
  }

  const onError = (errorResponse: Pick<TokenResponse, 'error' | 'error_description' | 'error_uri'>) => {
    console.log(errorResponse, 'errorResponse')
    alert(errorResponse.error)
    Sentry.captureException('구글 로그인 실패', { extra: { response: errorResponse } })
  }

  const login = useGoogleLogin({
    flow: 'implicit',
    onSuccess: (tokenResponse) => onSuccess(tokenResponse),
    onError: (errorResponse) => onError(errorResponse),
  })

  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    if (additionalOnClick) additionalOnClick()
    login()
  }

  return <div onClick={onClick}>{render}</div>
}

export default GoogleLogin
